<img
  class="flogo"
  src="/assets/logo.png"
  height="35px"
  alt="Fingaz"
/>
